import React from "react";

import { MenuAction } from "@tiny/components/src/DataTable/DataTable.types";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import { SuppressionTableProps } from "./SuppressionTable.types";
import { SuppressionInfoView } from "@tiny/api";

export function useSuppressionTable(props: SuppressionTableProps) {
  const {
    enableEdit,
    suppressions,
    onDelete,
    onColumnsSettingsClose,
    hideDelete,
  } = props;

  const { mdUp } = useBreakpoints();

  const [editOpen, setEditOpen] = React.useState(false);

  const [visibleColumns, setVisibleColumns] = React.useState<string[]>(() => {
    const visibleStored = localStorage.getItem("suppression-table-columns");
    return visibleStored ? JSON.parse(visibleStored) : [];
  });

  const deleteRow = React.useCallback(
    (row: SuppressionInfoView) => {
      const suppression = suppressions?.find((item) => item.id === row?.id);
      onDelete(suppression!);
    },
    [onDelete, suppressions]
  );

  const applyColumnsSettings = React.useCallback(
    (selected: string[]) => {
      localStorage.setItem(
        "suppression-table-columns",
        JSON.stringify(selected)
      );
      setVisibleColumns(selected);
      onColumnsSettingsClose();
    },
    [onColumnsSettingsClose]
  );

  const moreActions: MenuAction<SuppressionInfoView>[] = React.useMemo(() => {
    if (!enableEdit) {
      return [];
    }

    const deleteAction = { name: "Remove", onClickAction: deleteRow };

    return hideDelete ? [] : [deleteAction];
  }, [enableEdit, deleteRow, hideDelete]);

  return {
    editOpen,
    moreActions,
    visibleColumns,
    applyColumnsSettings,
    mdUp,
  };
}
